import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { DateAdapter } from '@angular/material/core';
import { RouterModule } from '@angular/router';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { AccountBaseService, CommonModule, MaterialModule } from 'common';
import { BusinessAdvisorInputComponent } from './business-advisor/business-advisor-input/business-advisor-input.component';
import { BusinessAdvisorPickerComponent } from './business-advisor/business-advisor-picker/business-advisor-picker.component';
import { BusinessAdvisorWidgetComponent } from './business-advisor/business-advisor-widget/business-advisor-widget.component';
import { BusinessNameInputComponent } from './business-name-input/business-name-input.component';
import { BrokerNameInputComponent } from './broker-name-input/broker-name-input.component';
import { CardComponent } from './card/card.component';
import { CdkExpandedRowDirective } from './cdk-expanded-row/cdk-expanded-row.directive';
import { LineChartComponent } from './charts/line-chart/line-chart.component';
import { TermLoanChartComponent } from './charts/term-loan-chart/term-loan-chart.component';
import { VerticalBarChartComponent } from './charts/vertical-bar-chart/vertical-bar-chart.component';
import { VerticalStackedBarChartComponent } from './charts/vertical-stacked-bar-chart/vertical-stacked-bar-chart.component';
import { ConfirmChangesDialogComponent } from './confirm-changes-dialog/confirm-changes-dialog.component';
import { ContentSliderComponent } from './content-slider/content-slider.component';
import { SignatureComponent } from './document/signature/signature.component';
import { NoteCardComponent } from './note/note-card/note-card.component';
import { AccountNotesSidenavComponent } from './notes-sidenav/account-notes-sidenav/account-notes-sidenav.component';
import { ApplicationNotesSidenavComponent } from './notes-sidenav/application-notes-sidenav/application-notes-sidenav.component';
import { OwnersWidgetComponent } from './owners-widget/owners-widget.component';
import { PanelComponent } from './panel/panel.component';
import { SigningWidgetComponent } from './signing-widget/signing-widget.component';
import { SalesforceUrlPipe } from './pipes/salesforce-url.pipe';
import { UpdateDialogComponent } from './update-dialog/update-dialog.component';
import { FedDateAdapter } from '../../../../common/src/lib/ui/datepicker/date-adapter.component';
import { AccountService } from '../account/account.service';

@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
        FlexLayoutModule,
        NgxChartsModule,
        RouterModule
    ],
    exports: [
        CommonModule,
        MaterialModule,
        ContentSliderComponent,
        FlexLayoutModule,
        CdkExpandedRowDirective,
        TermLoanChartComponent,
        BusinessAdvisorWidgetComponent,
        BusinessAdvisorPickerComponent,
        BusinessAdvisorInputComponent,
        BusinessNameInputComponent,
        BrokerNameInputComponent,
        CardComponent,
        PanelComponent,
        NoteCardComponent,
        AccountNotesSidenavComponent,
        VerticalBarChartComponent,
        LineChartComponent,
        VerticalStackedBarChartComponent,
        ApplicationNotesSidenavComponent,
        OwnersWidgetComponent,
        SigningWidgetComponent,
        SalesforceUrlPipe,
        UpdateDialogComponent,
        SignatureComponent,
        ConfirmChangesDialogComponent
    ],
    declarations: [
        ContentSliderComponent,
        CdkExpandedRowDirective,
        TermLoanChartComponent,
        BusinessAdvisorWidgetComponent,
        BusinessAdvisorPickerComponent,
        BusinessAdvisorInputComponent,
        BusinessNameInputComponent,
        BrokerNameInputComponent,
        CardComponent,
        PanelComponent,
        VerticalBarChartComponent,
        LineChartComponent,
        VerticalStackedBarChartComponent,
        PanelComponent,
        NoteCardComponent,
        AccountNotesSidenavComponent,
        ApplicationNotesSidenavComponent,
        OwnersWidgetComponent,
        SigningWidgetComponent,
        SalesforceUrlPipe,
        UpdateDialogComponent,
        SignatureComponent,
        ConfirmChangesDialogComponent
    ],
    providers: [
        {
            provide: DateAdapter,
            useClass: FedDateAdapter
        },
        {
            provide: AccountBaseService,
            useClass: AccountService
        }
    ]
})
export class SharedModule { }
